var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex justify-start w-full"},[_c('perfect-scrollbar',{staticClass:"border-solid border-soft rounded-lg p-4 ml-negative bg-soft",class:{
         'box-shadow border-focus': _vm.focus,
         'hover:border-focus': _vm.isClickable
       }},[_vm._t("text"),_vm._t("footer")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }